import React, { ReactNode } from "react";
import { Button } from "antd";

type ButtonProps = {
  title?: string | ReactNode;
  className?: string;
  variant?: "link" | "text" | "dashed" | "outlined" | "solid" | "filled";
  shape?: "round" | "circle";
  type?: "primary" | "link" | "text" | "default" | "dashed";
  btnColor?: "black" | "blue" | "success" | "danger" | "white" | "secondary" | "redButton" | "outline";
  isLoading?: boolean;
  disabled?: boolean;
  icon?: ReactNode;
  iconPosition?: "left" | "right";
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  htmlType?: "button" | "submit" | "reset";
  children?: ReactNode;
  textClassName?: string;
  ariaDisabled?: boolean;
  tabIndex?: number;
};

const btnColorClasses: Record<string, string> = {
  primary: "!bg-primaryGreen   !cursor-pointer  !text-white hover:!border-none hover:!outline-none",
  black: "!bg-[#001630] !text-white hover:!bg-gray-900",
  white: "!bg-white !text-black !border !border-gray-300 ",
  success: "!bg-[#16A34A] !text-white  hover:!border-none hover:!outline-none",
  danger: "!bg-gradient-to-r !from-[#DC2626] !to-[#B91C1C] !text-white hover:!from-[#D63E2C] hover:!to-[#E5503D] !border-none",
  blue: "!bg-[#9333EA] !text-white hover:!bg-[#7E22CE]/80 hover:!border-none hover:!outline-none",
  greenButton: "!bg-primaryGreen  !cursor-pointer  !text-white hover:!bg-primaryGreen hover:!to-[#E5503D] !border-none",
  secondary: "!bg-[#F9FAFB] !text-[#1F2937]  hover:!outline-none",
  outline: "!bg-white !text-[#1F3D2B] !border  !cursor-pointer  !border-[#1F3D2B] !font-semibold",

};

const CustomButton: React.FC<ButtonProps> = ({
  title,
  shape,
  iconPosition = "left",
  className = "",
  variant,
  type,
  onClick = () => {},
  htmlType = "submit",
  icon = null,
  btnColor,
  isLoading = false,
  disabled = false,
  children,
  textClassName = "",
  ariaDisabled,
  tabIndex,
}) => {
  const resolvedType: ButtonProps["type"] = btnColor ? "default" : type;
  return (
    <Button
      onClick={onClick}
      htmlType={htmlType}
      type={resolvedType}
      disabled={disabled}
      aria-disabled={ariaDisabled}
      tabIndex={tabIndex}
      variant={variant}
      shape={shape}
      loading={isLoading}
      
      className={`min-w-[50%] pl-[16px] pr-[16px] cursor-pointer !font-Nunito !font-semibold !rounded-[14px] !h-[50px] flex items-center gap-2 transition-all 
        ${btnColor ? btnColorClasses[btnColor] : ""} ${className} 
            ${disabled ? "!bg-primaryGreen !border-primaryGreen !text-white !opacity-100 cursor-not-allowed" : ""}
        `}
    >
      {icon && iconPosition === "left" && (
        <span className="flex items-center gap-2">{icon}</span>
      )}
      {title && <span className={`${textClassName}`}>{title}</span>}
      {children}
      {icon && iconPosition === "right" && (
        <span className="flex items-center gap-2">{icon}</span>
      )}
    </Button>
  );
};

export default CustomButton;
